<div style="padding: 20px;
margin-top: 10%;
width: 100%;
text-align: center;
">
    No data found
</div>
